// extracted by mini-css-extract-plugin
module.exports = {"btn":"src-components-Captcha-__index-module__btn--35tTG","captchInput":"src-components-Captcha-__index-module__captchInput--KqSZA"};